import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import Avatar from '@material-ui/core/Avatar';
import Input from '@material-ui/core/Input';
import { useMediaQuery } from 'react-responsive';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Switch } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { storeContext } from '../provider/Provider';
import PrimaryButton from '../../customUI/PrimaryButton';
import PrimaryContainer from '../../customUI/PrimaryContainer';
import theme from '../../theme';
import MobileTitle from '../../customUI/MobileTitle';
import { websiteSwitchActions } from '../../store/website-switch-reducer';
import { contentActions } from '../../store/content-reducer';
import { authActions } from '../../store/auth-reducer';

const { REACT_APP_AUTH0_API_URL, REACT_APP_FLASK_API_URL } = process.env;

const useStyles = makeStyles(() => ({
  container: {
    padding: 20,
    minHeight: 'unset',
    width: '40%',
    [theme.breakpoints.down('xs')]: {
      width: '85%',
    },
    textAlign: 'center',
    color: '#696969',
  },
  heading: {
    margin: 0,
    marginTop: 25,
    color: '#696969',
    fontWeight: 700,
  },
  label: {
    fontWeight: 700,
    fontSize: 17,
    display: 'inline-flex',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
    color: '#696969',
  },
  inputs: {
    marginTop: 50,
  },
  changeEmail: {
    '& .MuiButton-root': {
      marginTop: 25,
    },
  },
  message: {
    marginTop: 15,
  },
  subsMessage: {
    marginTop: 15,
  },
  siteAvatar: {
    margin: '25px auto',
    height: 100,
    width: 100,
    '& > img': {
      width: '100%',
    },
  },

  subBlock: {
    opacity: 0,
    transition: 'opacity 0.5s',
    marginTop: 20,
    marginBottom: 30,
    '& p': {
      fontWeight: 700,
      fontSize: 20,
      '&.infoSub': {
        fontWeight: 400,
        fontSize: 14,
      },
    },
    '& #subscriptionMessage': {
      maxWidth: '65%',
      marginLeft: 'auto',
      marginRight: 'auto',
      transition: 'opacity 1s',
    },
  },
  subsDivider: {
    width: '90%',
    marginTop: 20,
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: '#696969',
  },
  requirements: {
    display: 'none',
    transition: 'opacity 1s',
    textAlign: 'center',
    width: '20rem',
    [theme.breakpoints.down('xs')]: {
      width: '85%',
    },
    margin: 'auto',
    '& p': {
      color: theme.palette.secondary.main,
      textAlign: 'left',
    },
    '& p.filled': {
      color: theme.palette.primary.main,
      textAlign: 'left',
    },
  },
}));

const Settings = () => {
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const classes = useStyles();
  const { state, dispatch } = React.useContext(storeContext);
  const [cookies] = useCookies(['auth']);
  const [disabledButton, ChangeDisabledButton] = React.useState(true);
  const [oldPasswordInput, ChangeOldPasswordInput] = React.useState('');
  const [newPasswordInput, ChangeNewPasswordInput] = React.useState('');
  const [newPassword2Input, ChangeNewPassword2Input] = React.useState('');
  const [invalidPasswordInput, ChangeInvalidPasswordInput] = React.useState(false);
  const [validPasswordInput, ChangeValidPasswordInput] = React.useState(false);
  const [errorMessage, ChangeErrorMessage] = React.useState('');
  const [subscribeMessage, ChangeSubscribeMessage] = React.useState('');
  const [subscription, ChangeSubscription] = React.useState(true);
  const [alternateEmail, setAlternateEmail] = React.useState('');
  useEffect(() => {
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/assign-page-feature/${state.websiteSwitch.currentWebsite}`
      )
      .then((res) => {
        if (!res.data.error) {
          dispatch({
            type: websiteSwitchActions.WEBSITE_SWITCH_SET_ALL,
            payload: {
              currentWebsiteSettings: {
                assignPageFeature: res.data.data.assign_page_feature,
              },
            },
          });
        }
      });
    axios.get(`${REACT_APP_FLASK_API_URL}/get-alternative-email`).then((res) => {
      if (!res.data.error) {
        dispatch({
          type: authActions.AUTH_SET_ALL,
          payload: {
            user: {
              alternateEmail: res.data.data.alternative_email,
            },
          },
        });
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`${REACT_APP_FLASK_API_URL}/get-subscription`).then((res) => {
      if (!res.data.error) {
        ChangeSubscription(res.data.data.subscription);
        if (document.getElementById('subBlock')) {
          document.getElementById('subBlock').style.opacity = '1';
        }
      }
    });
    window.scrollTo(0, 0);
  }, [subscribeMessage, subscription]);

  const handleChangeAssignPageFeature = (event) => {
    dispatch({
      type: websiteSwitchActions.WEBSITE_SWITCH_SET_ALL,
      payload: {
        currentWebsiteSettings: {
          assignPageFeature: event.target.checked,
        },
      },
    });
    axios
      .post(
        `${REACT_APP_FLASK_API_URL}/v1/assign-page-feature/set/${state.websiteSwitch.currentWebsite}`,
        { assign_page_feature: event.target.checked }
      )
      .then((res) => {
        if (!res.data.error) {
          if (res.data.data.assign_page_feature === true) {
            axios
              .get(
                `${REACT_APP_FLASK_API_URL}/v1/assigned-pages/${state.websiteSwitch.currentWebsite}`
              )
              .then((resAssignedPages) => {
                if (!resAssignedPages.data.error) {
                  dispatch({
                    type: contentActions.CONTENT_SET_ALL,
                    payload: {
                      assignPageFeature: {
                        total: resAssignedPages.data.data.total,
                        rows: resAssignedPages.data.data.values,
                      },
                    },
                  });
                }
              });
          }
        }
      });
  };

  const handleChangePassword = () => {
    ChangeInvalidPasswordInput(false);
    ChangeValidPasswordInput(false);
    const data = {
      username: state.auth.user.email,
      password: newPasswordInput,
      idToken: cookies.id_token,
    };
    axios.post(`${REACT_APP_AUTH0_API_URL}/auth/change-password`, data).then((res) => {
      if (res.data.success) {
        ChangeValidPasswordInput(true);
      } else {
        ChangeInvalidPasswordInput(true);
        ChangeErrorMessage(
          'Something went wrong. Please check your old password data and try again.'
        );
      }
    });
  };

  function CheckRequirements(val) {
    let issues = 0;
    if (val === '') {
      document.getElementById('requirements').style.opacity = '0';
      setTimeout(() => {
        document.getElementById('requirements').style.display = 'none';
      }, 1000);
    } else {
      document.getElementById('requirements').style.display = 'block';
      setTimeout(() => {
        document.getElementById('requirements').style.opacity = '1';
      }, 50);
    }
    if (newPassword2Input === val) {
      document.getElementById('reqMatch').classList.add('filled');
    } else {
      document.getElementById('reqMatch').classList.remove('filled');
      issues += 1;
    }
    if (/\d/.test(val)) {
      document.getElementById('reqNum').classList.add('filled');
    } else {
      document.getElementById('reqNum').classList.remove('filled');
      issues += 1;
    }
    if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>`/?]+/.test(val)) {
      document.getElementById('reqSym').classList.add('filled');
    } else {
      document.getElementById('reqSym').classList.remove('filled');
      issues += 1;
    }
    if (/[A-Z]/.test(val)) {
      document.getElementById('reqUpper').classList.add('filled');
    } else {
      document.getElementById('reqUpper').classList.remove('filled');
      issues += 1;
    }
    if (val.length > 7) {
      document.getElementById('reqLen').classList.add('filled');
    } else {
      document.getElementById('reqLen').classList.remove('filled');
      issues += 1;
    }
    if (issues !== 0) {
      ChangeDisabledButton(true);
    } else {
      ChangeDisabledButton(false);
    }
  }
  function CheckConfirmation(val) {
    let issues = 0;
    if (newPasswordInput === val) {
      document.getElementById('reqMatch').classList.add('filled');
    } else {
      document.getElementById('reqMatch').classList.remove('filled');
      issues += 1;
    }
    if (!/\d/.test(newPasswordInput)) {
      issues += 1;
    }
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>`/?]+/.test(newPasswordInput)) {
      issues += 1;
    }
    if (!/[A-Z]/.test(newPasswordInput)) {
      issues += 1;
    }
    if (newPasswordInput.length > 7) {
      document.getElementById('reqLen').classList.add('filled');
    } else {
      document.getElementById('reqLen').classList.remove('filled');
      issues += 1;
    }
    if (issues !== 0) {
      ChangeDisabledButton(true);
    } else {
      ChangeDisabledButton(false);
    }
  }

  const handleSubscribe = () => {
    const data = {
      subscription_change: 'true',
    };
    axios.post(`${REACT_APP_FLASK_API_URL}/update-user`, data).then((res) => {
      if (res) {
        ChangeSubscribeMessage(
          `You were successfully ${
            !subscription ? 'subscribed to the' : 'unsubscribed from the'
          } HD Platform Performance Report`
        );
        ChangeSubscription(!subscription);
        document.getElementById('subscriptionMessage').style.display = 'block';
        document.getElementById('subscriptionMessage').style.opacity = '1';
        setTimeout(() => {
          document.getElementById('subscriptionMessage').style.opacity = '0';
        }, 5000);
        setTimeout(() => {
          document.getElementById('subscriptionMessage').style.display = 'none';
        }, 6000);
      } else {
        ChangeSubscribeMessage(`Something went wrong! Please try again.`);
        document.getElementById('subscriptionMessage').style.display = 'block';
        document.getElementById('subscriptionMessage').style.opacity = '1';
        setTimeout(() => {
          document.getElementById('subscriptionMessage').style.opacity = '0';
        }, 5000);
        setTimeout(() => {
          document.getElementById('subscriptionMessage').style.display = 'none';
        }, 6000);
      }
    });
  };

  const handleSetAlternateEmail = () => {
    if (alternateEmail) {
      axios
        .post(`${REACT_APP_FLASK_API_URL}/update-user`, { alternative_email: alternateEmail })
        .then((res) => {
          if (res.data.success) {
            dispatch({
              type: authActions.AUTH_SET_ALL,
              payload: {
                user: {
                  alternateEmail: res.data.alternative_email,
                },
              },
            });
          }
        });
    }
  };

  return (
    <>
      {isPhone && <MobileTitle title="Settings" />}
      <PrimaryContainer className={classes.container}>
        {state.websiteSwitch.currentWebsite ? (
          <Avatar
            alt="Site Icon"
            src={`https://hd-platform-icons.s3.us-west-1.amazonaws.com/Profile+Images/${state.websiteSwitch.currentWebsite}.png`}
            className={classes.siteAvatar}
          >
            <img
              src={`https://www.1google.com/s2/favicons?domain=${state.websiteSwitch.currentWebsite}`}
              alt="Site Icon"
            />
          </Avatar>
        ) : (
          <Avatar>HD</Avatar>
        )}
        <h1 className={classes.heading}>Account Settings</h1>
        <div className={classes.changeEmail}>
          <p style={{ margin: 0, marginTop: 15 }}>
            <b>{state.auth.user.name}</b>
          </p>
          <p style={{ margin: 0 }}>
            <b>{state.auth.user.email}</b>
          </p>
          <div className={classes.inputs}>
            <div>
              <p className={classes.label}>Old Password:</p>
              <Input
                inputProps={{ 'aria-label': 'Old Password' }}
                value={oldPasswordInput}
                type="password"
                data-testid="old_password_test_id"
                onChange={(e) => {
                  ChangeOldPasswordInput(e.target.value);
                }}
              />
            </div>
            <div>
              <p className={classes.label}>New Password:</p>
              <Input
                inputProps={{ 'aria-label': 'New Password' }}
                value={newPasswordInput}
                type="password"
                data-testid="new_password_test_id"
                onKeyUp={(e) => {
                  CheckRequirements(e.target.value);
                }}
                onChange={(e) => {
                  ChangeNewPasswordInput(e.target.value);
                }}
              />
            </div>
            <div>
              <p className={classes.label}>Confirm New Password:</p>
              <Input
                inputProps={{ 'aria-label': 'New Password' }}
                value={newPassword2Input}
                type="password"
                data-testid="new_password_2_test_id"
                onKeyUp={(e) => {
                  CheckConfirmation(e.target.value);
                }}
                onChange={(e) => {
                  ChangeNewPassword2Input(e.target.value);
                }}
              />
              <div className={classes.requirements} id="requirements">
                <p id="reqUpper">
                  <InfoOutlinedIcon /> At least 1 uppercase letter is required.
                </p>
                <p id="reqNum">
                  <InfoOutlinedIcon /> At least 1 number is required.
                </p>
                <p id="reqSym">
                  <InfoOutlinedIcon /> At least 1 symbol is required.
                </p>
                <p id="reqLen">
                  <InfoOutlinedIcon /> At least 8 characters are required.
                </p>
                <p id="reqMatch">
                  <InfoOutlinedIcon /> The password confirmation does not match the password.
                </p>
              </div>
            </div>
          </div>
          <PrimaryButton
            onClick={handleChangePassword}
            id="changePasswordButton"
            variant="contained"
            color="primary"
            component="span"
            data-testid="submit_button_test_id"
            disabled={disabledButton}
          >
            Change Password
          </PrimaryButton>
          {validPasswordInput && (
            <div className={classes.message}>Your password has been changed successfully.</div>
          )}
          {invalidPasswordInput && <div className={classes.message}>{errorMessage}</div>}
        </div>
        <Divider className={classes.subsDivider} />
        <div style={{ marginTop: 20 }}>
          <p style={{ fontSize: 20, fontWeight: 700 }}>Content Page Review Assignments</p>
          {state.websiteSwitch.currentWebsiteSettings.assignPageFeature ? (
            <p>
              Disabling this feature will not permit you to assign and receive page review requests.
            </p>
          ) : (
            <p>
              Enabling this feature will allow you to assign and receive content page review
              requests.
            </p>
          )}

          <Switch
            checked={state.websiteSwitch.currentWebsiteSettings.assignPageFeature}
            onChange={handleChangeAssignPageFeature}
            color="primary"
            name="assignPageFeature"
          />
        </div>
        <Divider className={classes.subsDivider} />
        <div className={classes.subBlock} id="subBlock">
          <p>Email Preferences</p>
          {subscription ? (
            <p className="infoSub">
              You are currently <b>subscribed</b> to the monthly HD Platform Permance Report.
            </p>
          ) : (
            <p className="infoSub">
              You are currently <b>unsubscribed</b> from the monthly HD Platform Permance Report.
            </p>
          )}
          {subscription
            ? (
                <p>
                  You are currently <b>subscribed</b> to the monthly HD Platform Permance Report.
                </p>
              ) && (
                <PrimaryButton
                  onClick={handleSubscribe}
                  variant="contained"
                  component="span"
                  color="secondary"
                  data-testid="unsub_button_test_id"
                >
                  Unsubscribe
                </PrimaryButton>
              )
            : (
                <p>
                  You are currently <b>unsubscribed</b> from the monthly HD Platform Permance
                  Report.
                </p>
              ) && (
                <PrimaryButton
                  onClick={handleSubscribe}
                  variant="contained"
                  component="span"
                  color="primary"
                  data-testid="sub_button_test_id"
                >
                  Subscribe
                </PrimaryButton>
              )}
          <div id="subscriptionMessage" className={classes.message}>
            {subscribeMessage}
          </div>
        </div>
        <Divider className={classes.subsDivider} />
        <div style={{ marginTop: 20 }}>
          <p style={{ fontSize: 20, fontWeight: 700 }}>Alternate Email</p>
          {state.auth.user.alternateEmail ? (
            <p className="infoSub">
              Your current alternate email is: {state.auth.user.alternateEmail}
            </p>
          ) : (
            <p className="infoSub">
              You can set up alternate email. You will be able to access google documents from
              content page using this email too.
            </p>
          )}
          <div>
            <Input
              value={alternateEmail}
              type="email"
              onChange={(e) => {
                setAlternateEmail(e.target.value);
              }}
            />
          </div>
          <div style={{ marginTop: 20 }}>
            <PrimaryButton
              onClick={handleSetAlternateEmail}
              variant="contained"
              component="span"
              color="primary"
              data-testid="sub_button_test_id"
            >
              Subscribe
            </PrimaryButton>
          </div>
        </div>
      </PrimaryContainer>
    </>
  );
};

export default Settings;
